<script lang="ts" setup>
defineOptions({
  name: 'PageHomeUnit',
});
import { ref } from 'vue';
import { UNIT_LIST, SUPPORTING_UNIT_LIST } from '@/constants'
const unitList = ref(UNIT_LIST)
</script>

<template>
  <section class="page-home-unit">
    <h2 class="mt-[128px]">共建单位</h2>
    <p>UNIT</p>
    <div class="flex-start mt-[32px] flex flex-wrap">
      <div class="card" v-for="(item, index) in unitList" :key="index">
        <div class="h-[72px] w-[200px]">
          <img :data-src="item" class="card-img lazyload" alt="">
        </div>
      </div>
    </div>

    <h2 class="mt-[128px]">支持单位</h2>
    <p>SUPPORTING UNIT</p>
    <div class="flex-start mt-[32px] flex flex-wrap">
      <div class="card" v-for="(item, index) in SUPPORTING_UNIT_LIST" :key="index">
        <div class="h-[72px] w-[200px]">
          <img :data-src="item" class="card-img lazyload" alt="">
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-home-unit {
  width: 1200px;
  margin: 0 auto;

  h2 {
    color: #00479d;
    font-weight: 500;
    font-size: 32px;
    line-height: 45px;
  }

  p {
    color: #00479d;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  .card-img {
    width: 100%;
    height: 100%;
  }
}
</style>
